/**
 * The internal imports
 */
import { colorModeConfig } from '../../utils/colorModeUtils'

export default {
  config: {
    colorModeConfig,
  },
}
